import React, { useState } from 'react';
import getInitials from '../../Utils/helper';

const ProfileInfo = ({ onlogout, userInfo }) => {

    const [showprofile, setshowprofile] = useState(false);


    const toggleshowProfile = () => {
        setshowprofile(!showprofile);
    }


    return (
        <div>

            <div onClick={toggleshowProfile} type="button" class="flex justify-center items-center w-12 h-12 rounded-full cursor-pointer text-slate-900 bg-slate-50"   >{getInitials(userInfo.fullname)}</div>


            {showprofile && (
                <div id="userDropdown" className="z-10 fixed top-15 right-10 width-50 bg-white divide-y divide-gray-100 rounded-lg shadow w-44">
                    <div className="px-4 py-3 text-sm text-center text-black">
                        <div>{userInfo.fullname}</div>
                        <div className="font-medium truncate">{userInfo.email}</div>
                    </div>
                    <div className="py-1">
                        <button onClick={onlogout} href="#" className="block px-4 py-2 text-sm text-black w-full hover:bg-gray-100 hover:text-black">Sign out</button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ProfileInfo
